export default __webpack_public_path__ + "static/media/left-calendar-icon.86c6892c.svg";